import axios from 'axios'
import { Message } from 'element-ui'

const baseURL = process.env.VUE_APP_API_BASE_URL || '/api/admin'

const service = axios.create({
  baseURL: baseURL,
  timeout: 15000
})

let unauthorizedHandling = false

const __METHOD_NEEDS_LOADING = ['POST', 'PUT', 'DELETE', 'PATCH']

function handleUnauthorized(message = '登录已过期，请重新登录') {
  localStorage.removeItem('admin_token')
  localStorage.removeItem('admin_username')
  if (!unauthorizedHandling) {
    unauthorizedHandling = true
    Message.error(message)
    window.location.hash = '#/login'
    setTimeout(() => {
      unauthorizedHandling = false
    }, 2000)
  }
}

// 请求拦截器 - 添加 token + 显示全局加载遮罩
service.interceptors.request.use(
  config => {
    const token = localStorage.getItem('admin_token')
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token
    }
    const method = ((config && config.method) || '').toUpperCase()
    if (__METHOD_NEEDS_LOADING.includes(method) && !config._noGlobalLoading) {
      config._showLoading = true
      if (window.__showPageLoading) {
        window.__showPageLoading()
      }
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截器 - 隐藏全局加载遮罩 + 业务逻辑
service.interceptors.response.use(
  response => {
    // 先隐藏 loading（不管业务逻辑成功还是失败）
    const config = response.config
    if (config && config._showLoading) {
      config._showLoading = false
      if (window.__hidePageLoading) {
        window.__hidePageLoading()
      }
    }
    const res = response.data
    if (res.code !== 200) {
      if (res.code === 401) {
        handleUnauthorized(res.message || '登录已过期，请重新登录')
      } else {
        if (res.message) Message.error(res.message)
      }
      return Promise.reject(new Error(res.message || '请求失败'))
    }
    return res
  },
  error => {
    // 先隐藏 loading
    const config = error.config || {}
    if (config._showLoading) {
      config._showLoading = false
      if (window.__hidePageLoading) {
        window.__hidePageLoading()
      }
    }
    const status = error.response && error.response.status
    if (status === 401) {
      const data = error.response.data || {}
      handleUnauthorized(data.message || '登录已过期，请重新登录')
    } else {
      Message.error(error.message || '网络错误')
    }
    return Promise.reject(error)
  }
)

export default service
